import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Collapse from '@material-ui/core/Collapse'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPaypal } from '@fortawesome/free-brands-svg-icons'
import {
    METHOD_ACCENT,
    METHOD_BG,
    METHOD_BG_HOVER,
    METHOD_BORDER,
    METHOD_FONT,
    METHOD_LABEL_SIZE,
    METHOD_LABEL_WEIGHT,
    METHOD_PADDING,
    METHOD_RADIUS,
    METHOD_SHADOW,
    METHOD_SPACING,
    METHOD_TEXT,
    METHOD_TRANSITION,
} from '../checkoutAppearance'

// PayPal is not a Stripe payment method, so its row cannot come out of the Payment Element — it is
// built by hand from the same METHOD_* tokens the Stripe appearance is built from, which is the only
// reason it can sit in the element's list without looking bolted on. GY does the same; the difference
// is that GY's checkout has a summary step to defer the real PayPal button to, and this one does not:
// PayPal's popup must be opened from PayPal's own rendered button, so expanding the row is what
// reveals it — the way PGC's single-page checkout does it (their CheckoutForm.tsx, PGC-7636).
const useStyles = makeStyles(() => ({
    methodRow: {
        fontFamily: METHOD_FONT,
        marginTop: METHOD_SPACING,
        marginBottom: METHOD_SPACING,
        backgroundColor: METHOD_BG,
        border: `1px solid ${METHOD_BORDER}`,
        borderRadius: METHOD_RADIUS,
        boxShadow: METHOD_SHADOW,
        transition: METHOD_TRANSITION,
        '&:hover': {
            backgroundColor: METHOD_BG_HOVER,
        },
    },
    methodRowOpen: {
        backgroundColor: METHOD_BG_HOVER,
    },
    methodRowHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: METHOD_PADDING,
        cursor: 'pointer',
        outline: 'none',
    },
    methodIcon: {
        color: '#253B80',
        fontSize: '1.4rem',
        marginRight: 12,
    },
    methodLabel: {
        color: METHOD_TEXT,
        fontSize: METHOD_LABEL_SIZE,
        fontWeight: METHOD_LABEL_WEIGHT,
    },
    methodLabelOpen: {
        color: METHOD_ACCENT,
    },
    methodRowContent: {
        padding: METHOD_PADDING,
        paddingTop: 0,
    },
}))

const PayPalAccordionRow = ({ open, onToggle, children }) => {
    const classes = useStyles()

    return (
        <div
            className={`${classes.methodRow} ${
                open ? classes.methodRowOpen : ''
            }`}
            data-testid="paypal-accordion-row"
        >
            <div
                className={classes.methodRowHeader}
                role="button"
                tabIndex={0}
                aria-expanded={open}
                onClick={() => onToggle(!open)}
                onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault()
                        onToggle(!open)
                    }
                }}
            >
                <FontAwesomeIcon icon={faPaypal} className={classes.methodIcon} />
                <span
                    className={`${classes.methodLabel} ${
                        open ? classes.methodLabelOpen : ''
                    }`}
                >
                    PayPal
                </span>
            </div>
            {/* unmountOnExit stays false: tearing the PayPal SDK button down on every collapse would
                re-run its initialisation each time the row opens. */}
            <Collapse in={open} timeout="auto" unmountOnExit={false}>
                <div className={classes.methodRowContent}>{children}</div>
            </Collapse>
        </div>
    )
}

export default PayPalAccordionRow
